import { CatalogCountry, CatalogOccasion } from './occasion-catalog'
import { coversEveryRegion, descendantCodes, topLevelOf } from './country-selection'

// Which regions of a country have holidays of their own, and which occasions
// those are. The country page lists occasions in date order and picks regions
// separately, so nothing here groups the list — this is what fills the region
// picker. Pure: the page only renders what this returns.

// The same rule the calendar gates on, so a day the picker treats as the
// country's own is a day every subscription carries. Keeping two copies of it
// is what emptied Britain's list.
export const isNationwide = (occasion: CatalogOccasion, country: CatalogCountry): boolean =>
    coversEveryRegion(occasion, country.regions)

// The top-level regions that carry a holiday the nationwide set does not, in
// catalog order. Seventeen of the fifty-two US regions carry nothing of their
// own, and a picker that offers them promises something it cannot give.
export function regionsWithExtras(
    country: CatalogCountry,
    definitions: CatalogOccasion[],
): string[] {
    const found = new Set<string>()
    for (const occasion of definitions) {
        if (isNationwide(occasion, country)) continue
        for (const code of occasion.regions ?? []) {
            found.add(topLevelOf(code, country.regions))
        }
    }
    return country.regions.filter(r => !r.parent && found.has(r.code)).map(r => r.code)
}

export function extraIdsFor(
    country: CatalogCountry,
    definitions: CatalogOccasion[],
    regionCode: string,
): string[] {
    const wanted = new Set(descendantCodes(regionCode, country.regions))
    return definitions
        .filter(d => !isNationwide(d, country) && (d.regions ?? []).some(r => wanted.has(r)))
        .map(d => d.id)
}
